/**
 * A tap anywhere on a date opens its calendar, as a phone does on its own; a
 * desktop browser opens it only from the icon. Where it cannot, the field
 * still takes the date typed.
 *
 * `<input type="date" onClick={openDatePicker} … />`
 */
export const openDatePicker = (event) => {
  try {
    event.currentTarget.showPicker?.();
  } catch {
    // Not allowed here (an embedded frame): the browser keeps its own way.
  }
};
